import * as transPredictionByBuildingActions from '../actions/trans-prediction-by-building.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface TransPredictionByBuildingState {
    transPredictionByBuilding: any;
    loading: boolean;
    loaded: boolean;
}

const initialState = {
    transPredictionByBuilding: null,
    loading: false,
    loaded: false
};

export const transPredictionByBuildingReducer = (state = initialState, action) => {
    switch (action.type) {
        case transPredictionByBuildingActions.GET_TRANS_PREDICTION_BY_BUILDING_LIST:
            return {
                ...state,
                loading: true,
                loaded: state.loaded
            };
        case transPredictionByBuildingActions.GET_TRANS_PREDICTION_BY_BUILDING_LIST_SUCCESS:
            return {
                ...state,
                transPredictionByBuilding: action.payload,
                loading: false,
                loaded: true,
            };
        case transPredictionByBuildingActions.GET_TRANS_PREDICTION_BY_BUILDING_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        case transPredictionByBuildingActions.CLEAR_TRANS_PREDICTION_BY_BUILDING_LIST:
            return {
                ...state,
                error: null,
                transPredictionByBuilding: null,
                loading: false,
                loaded: false
            };
        default:
            return state;
    }
};

export const getTransPredictionByBuildingState = createFeatureSelector<TransPredictionByBuildingState>('transPredictionByBuildingReducer');

export const getTransPredictionByBuildingList = (state: TransPredictionByBuildingState) => state.transPredictionByBuilding;
export const getTransPredictionByBuildingListLoaded = (state: TransPredictionByBuildingState) => state.loaded;
